import { ArrowBackIcon, ArrowForwardIcon, StarIcon } from '@/components/icons'
import { Autoplay, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.min.css'

const sliderData = [
  {
    name: 'Pat Rolfes',
    title: 'Newport Beach Pickleball Events',
    testimonial:
      'DUPR is a dream! Their app-driven, real-time, accurate player rating system, in conjunction with the league and ladder platforms, give our members competitive, fun matches and me a simple way to manage it all.',
  },
  {
    name: 'Riley Stockwell',
    title: 'Pickles New England - Coach',
    testimonial:
      'I’ve been using the DUPR app to help with the rating sessions I run at my club Pickles New England. It’s been really fun for the players including match play into a process that used to be sterile and nerve wracking for some. The new technology is exciting and I’m very much looking forward to incorporating into our future ladders and competitive events.',
  },
]

const doubleSliderData = sliderData.concat(sliderData)
// NOTE: This variable only uses for this data. Because we need to slide on Desktop. If adding more data, we don't need this anymore

export const Testimonials = () => {
  return (
    <div className="bg-gradient-to-r from-iceBlue to-paleBlue">
      <div className="container mx-auto px-4 md:px-10 py-8 md:py-20">
        <div className="flex flex-col gap-y-3 md:gap-y-6 items-center">
          <p className="text-azul text-xl font-semibold mb-0 text-center">Testimonials</p>
          <p className="text-navyBlue text-5xl leading-tight font-semibold mb-0 text-center">
            What our Customers are Saying
          </p>
          <div className="w-full mt-3">
            <div className="lg:mx-10 relative">
              <Swiper
                className="sm:px-5"
                modules={[Navigation, Autoplay, Pagination]}
                spaceBetween={50}
                slidesPerView={1}
                navigation={{
                  nextEl: '.swiper-nav-control  .swiper-button-next',
                  prevEl: '.swiper-nav-control .swiper-button-prev',
                }}
                loop
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                breakpoints={{
                  1025: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                  },
                }}
              >
                {doubleSliderData.map((slider, id) => (
                  <SwiperSlide key={`${id + 1}`}>
                    <div className="flex flex-col p-5 justify-between bg-white min-h-[320px] lg:h-96 rounded-md shadow-lg">
                      <div className="flex">
                        <StarIcon className="w-5 h-5 text-fadedOrange m-0.5" />
                        <StarIcon className="w-5 h-5 text-fadedOrange m-0.5" />
                        <StarIcon className="w-5 h-5 text-fadedOrange m-0.5" />
                        <StarIcon className="w-5 h-5 text-fadedOrange m-0.5" />
                        <StarIcon className="w-5 h-5 text-fadedOrange m-0.5" />
                      </div>
                      <div className="flex-grow text-darkNavy pt-3 text-base max-w-md 2xl:max-w-lg">
                        {slider.testimonial}
                      </div>

                      <div>
                        <p className="text-base text-darkNavy font-semibold text-left">{slider.name}</p>
                        <p className="text-base text-steel">{slider.title}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="swiper-nav-control">
                <ArrowBackIcon className="hidden sm:block -left-8 swiper-button-prev p-1 h-10 w-auto border border-azul hover:bg-lightBlue hover:text-azul text-azul" />
                <ArrowForwardIcon className="hidden sm:block -right-8 swiper-button-next p-1 h-10 w-auto border border-azul hover:bg-lightBlue hover:text-azul text-azul" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
